import { useState } from "react";

import moment from "moment/moment";

import { fetchMeteomaticsAQIData } from "../api/apiRequests";
import cities from "./../data/cities.json";

import { CACHE_DURATION } from "../constants/constants";

const useDataFetch = () => {
  const datetime = moment()
    .utc()
    .startOf("hour")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");

  const [airQualityData, setAirQualityData] = useState(null);

  const fetchAirQualityByCity = async () => {
    const cacheKey = "air_quality_data";
    const cacheTimeKey = "air_quality_data_time";

    const cached = localStorage.getItem(cacheKey);
    const cachedTime = localStorage.getItem(cacheTimeKey);

    if (
      cached &&
      cachedTime &&
      Date.now() - Number(cachedTime) < CACHE_DURATION
    ) {
      setAirQualityData(JSON?.parse(cached));
      return;
    }

    try {
      const result = await fetchMeteomaticsAQIData(datetime);
      if (!result) return;

      const matchedCitiesWithAQI = cities.map((city) => {
        const matched = result.find((coord) => {
          const latDiff = Math.abs(coord.lat - city.lat);
          const lonDiff = Math.abs(coord.lon - city.lon);
          return latDiff < 1 && lonDiff < 1;
        });

        return {
          city: city.city,
          lat: city.lat,
          lon: city.lon,
          aqi:
            matched?.dates?.[0]?.value !== null &&
            matched?.dates?.[0]?.value !== undefined
              ? matched?.dates[0].value
              : 0,
        };
      });

      setAirQualityData(matchedCitiesWithAQI);

      localStorage.setItem(cacheKey, JSON.stringify(matchedCitiesWithAQI));
      localStorage.setItem(cacheTimeKey, Date.now().toString());
    } catch (error) {
      if (cached) setAirQualityData(JSON.parse(cached));
      console.error(error);
    }
  };

  return {
    airQualityData,
    fetchAirQualityByCity,
  };
};

export default useDataFetch;
